import { Badge } from 'antd'

import {
  CANCELLATION_STATUSES,
  type CancellationStatus,
  type CancellationStatusConfig,
} from './cancellationStatusConfig'

export function createCancellationTabItems(
  statusConfig: CancellationStatusConfig,
  counts: Record<CancellationStatus, number>,
) {
  return CANCELLATION_STATUSES.map((status) => ({
    key: status,
    label: (
      <span data-testid={`cancellation-list-tab-${status.toLowerCase()}`}>
        {statusConfig[status].label}{' '}
        <Badge count={counts[status]} showZero={false} overflowCount={999} />
      </span>
    ),
  }))
}
